import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Form, Label, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../../reducers/common/localization";
import { SUB_ROLES_TRANSLATIONS } from '../../../../reducers/account/role';

class RemoveEmployeeFromGroupModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="accreditation-group-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <Form onSubmit={this.handleSubmit}>
                <Label>
                    {_.get(this.props.translation, 'org_staff.accreditation_groups.remove_employee_from_group_alert')}
                </Label>
                <Row className="modal-form-field-container">
                    <Col sm={3}>
                        {_.get(this.props.translation, 'org_staff.accreditation_groups.role_label')}:
                    </Col>
                    <Col>
                        {_.get(this.props.translation, 'roles.' + SUB_ROLES_TRANSLATIONS[this.props.data.role])}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={3}>
                        {_.get(this.props.translation, sharedLabelsPath.first_name_label)}:
                    </Col>
                    <Col>
                        {this.props.data.identityAlias.firstName}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={3}>
                        {_.get(this.props.translation, sharedLabelsPath.last_name_label)}:
                    </Col>
                    <Col>
                        {this.props.data.identityAlias.lastName}
                    </Col>
                </Row>
                <Row className="modal-form-field-container">
                    <Col sm={3}>
                        {_.get(this.props.translation, sharedLabelsPath.email_label)}:
                    </Col>
                    <Col>
                        {this.props.data.email}
                    </Col>
                </Row>
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            type="submit">{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </Form>
        );
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.onEmployeeRemoveFromGroup(this.props.groupId, this.props.data.id, this.props.data.role);
    };

    handleCancel = () => {
        this.props.onCancel();
        this.props.onCancelRemoving();
    };
}

RemoveEmployeeFromGroupModal.propTypes = {
    groupId: PropTypes.string,
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onEmployeeRemoveFromGroup: PropTypes.func,
    onCancel: PropTypes.func,
    onCancelRemoving: PropTypes.func
};

export default RemoveEmployeeFromGroupModal;



// WEBPACK FOOTER //
// ./src/components/staffMemberManagement/AccreditationGroupModal/RemoveEmployeeFromGroupModal/RemoveEmployeeFromGroupModal.js